<template>
    <form class="">
        <is-loading v-if="isLoading" :box="true" />
        <div class="form-group mb-3">
          <label>Select Requirements</label>
            <multiselect :options="requirements"
              searchable
              mode="tags"
              valueProp="id"
              label="name" track-by="id"
              :multiple="true"
              :hide-selected="true"
              :close-on-select="false"
              v-model="data.items" placeholder="--select requirements--"></multiselect>
        </div>
        <div class="d-flex mt-3 justify-content-end">
          <b-button variant="primary" @click.prevent="save()" type="button"> Submit </b-button>
        </div>
    </form>
</template>

<script>
import IsLoading from '@/components/IsLoading.vue'
import Multiselect from 'vue-multiselect'

export default {
    components:{ IsLoading, Multiselect},
    props:{
        editItem:{
            type: Object,
            default: null
        },
    },
    data(){
        return{
            isLoading: false,
            data: {
                items: [],
            },
        }
    },
    computed:{
        requirements(){
            return this.$store.state.requirement.list.map(i => {
                return {
                    id: i.id, name: `${i.name} - (${i.type})`
                }
            });
        },
    },
    methods:{
        save() {
            this.$validator.validateAll().then(result => {
                if (!result) {this.alertError("Form not valid"); return }
                const formData = new FormData()
                this.$store.dispatch("changeLoaderValue", true)
                formData.append('data', JSON.stringify(this.data))
                this.$http.post(`/requirement-sections/${this.editItem.id}/update-items`, formData)
                .then((response) => {
                    this.$store.dispatch("changeLoaderValue", false)
                    if(response.data.success){
                        this.$emit("updated", response.data.data)
                        this.resetForm();
                    }
                })
            })
        },
        resetForm(){
            this.$validator.reset()
            this.$emit("closeMe")
        },
        getOptionData(){
            this.isLoading = true;
            this.$store.dispatch('requirement/fetchAllItems')
            .then(response => this.isLoading = false );
        },
    },
    mounted(){
        this.getOptionData()
        this.data.items = this.editItem.requirements.map(i => {
            return {  id: i.id, name: `${i.name} - (${i.type})` }
        });
    }
}
</script>

<style>

</style>